import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=88d6ab54&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports